"use client"

import { useGLTF } from "@react-three/drei"
import { cn } from "@abraxas/ui/lib"
import { ModelViewer } from "@abraxas/ui/3d"

const LOCK_HERO_GLB =
  "https://lock.nyc3.cdn.digitaloceanspaces.com/assets/3d/Loomlock2025clockup.glb"

useGLTF.preload(LOCK_HERO_GLB)

export function HomeHeroLockModel({ className }: { className?: string }) {
  return (
    <div
      aria-hidden
      className={cn(
        "relative shrink-0",
        "md:rotate-12",
        "size-[max(60vw,40px)]",
        "md:size-[35vw]",
        "lg:size-[35vw]",
        "xl:size-[50vw]",
        "2xl:size-[45vw]",
        "max-h-[80vh] max-w-[80vh]",
        className,
      )}
    >
      <ModelViewer
        model="lock"
        enableRotate
        autoRotate
        autoRotateSpeed={2}
        hoveredDisableRotate
        className="h-full w-full"
      />
    </div>
  )
}
